'use client';

import React, { useRef } from 'react';

interface PackageCategoryTabsProps {
  categories: string[];
  active: string;
  onChange: (cat: string) => void;
}

export default function PackageCategoryTabs({
  categories,
  active,
  onChange,
}: PackageCategoryTabsProps) {
  const scrollRef = useRef<HTMLDivElement>(null);

  return (
    <div
      ref={scrollRef}
      className="flex items-center gap-2 overflow-x-auto scroll-hide pb-1"
    >
      {categories.map((cat) => (
        <button
          key={`cat-tab-${cat}`}
          onClick={() => onChange(cat)}
          className={`filter-chip flex-shrink-0 ${active === cat ? 'active' : ''}`}
        >
          {cat}
        </button>
      ))}
    </div>
  );
}